import React from 'react';
import { Alert } from 'antd';
import { useLocalStorageState } from 'ahooks';
import styled from 'types/theme.types';
import { FormattedMessage } from 'react-intl';

const CURRENT_BANNER_ID = 'project-introspect-early-access';

const BANNER_LINK = 'https://www.envzero.com/early-access-project-introspect';

const AnnouncementBanner: React.FC = () => {
  const [dismissed, setDismissed] = useLocalStorageState<boolean>(
    `announcement-banner-dismissed-${CURRENT_BANNER_ID}`,
    {
      defaultValue: false
    }
  );

  if (dismissed) {
    return null;
  }

  return (
    <StyledAlert
      data-e2e="announcement-banner"
      type="info"
      banner
      showIcon={false}
      closable
      onClose={() => setDismissed(true)}
      message={
        <BannerContent>
          <span>
            <FormattedMessage id="announcement.banner.message" />
          </span>
          <BannerLink data-e2e="announcement-banner-cta" href={BANNER_LINK} target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="announcement.banner.cta" />
          </BannerLink>
        </BannerContent>
      }
    />
  );
};

const StyledAlert = styled(Alert)`
  &.ant-alert {
    padding: 6px 20px;
    background-color: ${({ theme }) => theme.limeYellow};
  }

  .ant-alert-message {
    color: ${({ theme }) => theme.secondaryBlack};
    font-size: 14px;
  }

  .ant-alert-close-icon {
    color: ${({ theme }) => theme.secondaryBlack};

    &:hover {
      opacity: 0.6;
    }
  }
`;

const BannerContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

const BannerLink = styled.a`
  color: ${({ theme }) => theme.secondaryBlack};
  font-weight: 600;
  text-decoration: underline;

  &:hover {
    opacity: 0.7;
  }
`;

export default AnnouncementBanner;
